"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JobsController = function () {
  function JobsController(JobsService, FilterService, AuthService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, JobsController);
    this.jobsService = JobsService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(JobsController, [{
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.jobsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          template: "No match found. Change your filter criteria."
        },
        columns: [{
          field: "postDate", title: "Posted On", filterable: false, width: "4rem",
          template: "<span>#= kendo.toString(new Date(postDate), 'dd-MM-yyyy') #</span>"
        }, { field: "jobType", title: "Job Type", filterable: false, sortable: false, width: "8rem", template: function template(dataItem) {
            return "" + _this._getJobTypeText(dataItem.jobType);
          } }, { field: "jobReference", title: "Job Reference", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return _this._getJobReferenceCell(dataItem);
          } }, { field: "jobStatus", title: "Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getJobStatusText(dataItem.jobStatus);
          } }, { field: "totalInvites", title: "Helper Stats", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getHelperStats(dataItem);
          } }, { field: "totalInvites", title: "Open Rate", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getOpenRate(dataItem);
          } }, { field: "managedBy", title: "Mgmt", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getManagedByText(dataItem.managedBy);
          } }, { field: "estimatedJobValue", title: "Job Value", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return kendo.toString(dataItem.estimatedJobValue, 'c0');
          } }, {
          field: "ownerFullName", title: "Job Owner", filterable: false, sortable: false, width: "8rem",
          template: "<a class=\"cell\" href=\"#= '/users/' + ownerUserId #\">#= ownerFullName #</a>"
        }, {
          field: "addressState", title: "State", filterable: false, width: "4rem",
          template: "<span>#= (country === 'au' ? addressState.toUpperCase() : addressState) #</span>"
        },
        // {
        //   field: "ownerUserId", title: "User Id", filterable: false, sortable: false,width: "4rem",
        // },
        {
          field: "jobDate", title: "Start Date", filterable: false, width: "4rem",
          template: "<span>#= kendo.toString(new Date(jobDate), 'dd-MM-yyyy') #</span>"
        },
        // {
        //   field: "jobFinishDate", title: "Finish Date", filterable: false, sortable: false, width: "4rem",
        //   template: `<span>#= jobType != 1 ? kendo.toString(new Date(jobFinishDate), 'dd-MM-yyyy') : "-" #</span>`,
        // },
        {
          field: "expirationDate", title: "Expiry Date", filterable: false, sortable: false, width: "4rem",
          template: "<span>#= kendo.toString(new Date(expirationDate), 'dd-MM-yyyy') #</span>"
        }, { field: "ownerNumberOfPostedJobs", title: "# Jobs", filterable: false, sortable: false, width: "5rem" }]
      };
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.jobsMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }

    // Links always use the internal ID; only the label shows the user-facing reference.

  }, {
    key: "_getJobReferenceCell",
    value: function _getJobReferenceCell(dataItem) {
      var reference = kendo.htmlEncode(dataItem.jobReference || String(dataItem.id));
      var cell = "<a class=\"cell\" href=\"/jobs/" + dataItem.id + "\">" + reference + "</a>";

      if (dataItem.isRepost && dataItem.relatedJobId) {
        var originalReference = kendo.htmlEncode(dataItem.relatedJobReference || String(dataItem.relatedJobId));
        cell += "<div class=\"repost-of\">Repost of <a class=\"cell\" href=\"/jobs/" + dataItem.relatedJobId + "\">" + originalReference + "</a></div>";
      }

      return cell;
    }
  }, {
    key: "_getHelperStats",
    value: function _getHelperStats(dataItem) {
      return dataItem.activeInvites + " / " + dataItem.totalInvites;
    }
  }, {
    key: "_getOpenRate",
    value: function _getOpenRate(dataItem) {
      var activity = dataItem.activeInvites + " / " + dataItem.totalInvites;
      var openRate = dataItem.activeInvites / dataItem.totalInvites;
      return kendo.format('{0:p0}', openRate);
    }
  }, {
    key: "_getJobTypeText",
    value: function _getJobTypeText(type) {
      switch (type) {
        case _constants2.default.jobType.BABYSITTING:
          return "Babysitting";
        case _constants2.default.jobType.NANNYING:
          return "Nannying";
        case _constants2.default.jobType.AFTER_SCHOOL_CARE:
          return "After School Care";
        case _constants2.default.jobType.BEFORE_SCHOOL_CARE:
          return "Before School Care";
        case _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE:
          return "Before/After School Care";
        case _constants2.default.jobType.AU_PAIR:
          return "Au Pair";
        case _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING:
          return "Primary School Tutoring";
        case _constants2.default.jobType.HIGH_SCHOOL_TUTORING:
          return "High School Tutoring";
        case _constants2.default.jobType.ONE_OFF_ODD_JOBS:
          return "Odd Job";
      }
    }
  }, {
    key: "_getJobStatusText",
    value: function _getJobStatusText(status) {
      switch (status) {
        case _constants2.default.jobStatus.PENDING:
          return "Pending";
        case _constants2.default.jobStatus.AWARDED:
          return "Awarded";
        case _constants2.default.jobStatus.CANCELLED:
          return "Cancelled";
        case _constants2.default.jobStatus.COMPLETED:
          return "Completed";
        case _constants2.default.jobStatus.FILLED:
          return "Filled";
        case _constants2.default.jobStatus.FILLED_AND_CANCELLED:
          return "Filled and Closed";
      }
    }
  }, {
    key: "_getManagedByText",
    value: function _getManagedByText(status) {
      switch (status) {
        case _constants2.default.managedBy.USER:
          return "DIY";
        case _constants2.default.managedBy.SYSTEM:
          return "Assist";
      }

      return "";
    }
  }]);
  return JobsController;
}();

exports.default = JobsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/jobs/jobs.controller.js
 **/